import {Button} from 'antd'
import {getChannelsByProps_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import {channelSchema} from 'apis/schema'
import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useMemo, useState} from 'react'
import {useLocation} from 'react-use'
import {compose, fromRenderProps} from 'recompose'
import {staticPaths} from 'routes/staticPaths'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey} from 'views/AppLocals/hooks/usePaginationHelper'
import ListHeader from 'views/AppLocals/Templates/items/ListHeader'
import {renderChannelItem} from 'views/MainPage/functions/renderChannelItem'
import {NullAsDefault} from 'views/Shared'
import WorkspaceContext from '../WorkspaceContext'
import {useRouteSearchParam} from "../../../envs/_current/history";
import {NoneStickyMeta} from "../../AppLocals/EntityList";

const ChannelEntity = ({item, children, defaultItem}) => (
    <SelectEntityItem
        item={item}
        defaultItem={defaultItem}
        schema={channelSchema}>
        {(data) => children(data)}
    </SelectEntityItem>
)

const WorkspaceChannelList = ({
                                  owner_id,
                                  owner_type,
                                  Wrapper = 'div',
                                  filter_actions = {
                                      sortBy: 'sort-by',
                                      keyword: 'keyword',
                                  },
                              }) => {
    const t = useTranslate()

    const location = useLocation()

    const history = useHistory()

    const [refreshKey, setRefreshKey] = useState()
    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const refresh_deps = useMemo(
        () => [
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        renderFilter: NullAsDefault,
        AdvancedFilter: NullAsDefault,
        query_params: filter_actions,
        withKey: createPagerKey(refresh_deps),
        pagerInfo: {
            RenderEntity: ChannelEntity,
            query: bindQueryParams([{type: owner_type}, {id: owner_id}]),
            PaginationMeta: NoneStickyMeta,
            apiInfo: getChannelsByProps_Api,
            renderItem: renderChannelItem,
            renderWrap: (child) => (
                <div className="flex flex-col gap-2">
                    {child}
                </div>
            ),
        },
        renderHeader: ([searchBar, filterBar]) => (
            <React.Fragment>
                <ListHeader
                    title="channels"
                    extra={
                        <Button
                            type="primary"
                            className="button-rounded-lg no-border"
                            onClick={() => {
                                history.push({
                                    ...staticPaths.createChannel,
                                    search:
                                        '?' +
                                        new URLSearchParams({
                                            owner_id,
                                            owner_type,
                                        }).toString(),
                                })
                            }}>
                            {t('create')}
                        </Button>
                    }
                />
                {filterBar}
                <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-3">
                        {searchBar}
                    </div>
                </div>
            </React.Fragment>
        ),
    })

    return (
        <Wrapper className="flex flex-col space-y-3">
            {pager_widget}
        </Wrapper>
    )
}

export default compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        owner_id: getId(organization),
        owner_type: getType(organization),
    }))
)(WorkspaceChannelList)
